<template>
  <div class="grid h-100vh">
    <div class="grid-title">
      <h4>{{ $t("MANAGE_SYNC_OTA") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset d-main">
        <v-progress-linear
            color="warning"
            :indeterminate="true"
            rounded
            height="3"
            v-if="isLoading || isLoadingToken"
        ></v-progress-linear>
        <div v-if="!isLoading" class="h-100">
            <div>
              <v-btn-toggle v-model="actionTab" tile  color="primary accent-3" group>
                <v-btn value="SALE_CHANNEL" class="m-0" v-if="!isVisibleChannel">
                {{$t('SALE_CHANNEL')}}
                </v-btn>
                
                <v-btn value="OTA_CONNECT" class="m-0" v-if="!isVisibleMap">
                {{$t('CONNECTED_OTA')}}
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-divider />
            <v-row v-if="!isVisibleChannel && actionTab === 'SALE_CHANNEL'">
              <template v-if="listOTAConnected.length > 0">
                <v-col sm="3" class="pb-0 pt-0">
                  <v-list dense class="pt-0">
                      <v-list-item-group mandatory v-model="selectedItem">
                      <v-list-item
                          v-for="(item, i) in listOTAConnected"
                          :key="i"
                          :value="item.id"
                      >
                          <v-list-item-content>
                          <v-list-item-title
                              v-text="item.otaI18n.find(x => x.lang == defaultI18n).name"
                          >
                          </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon>
                          <v-progress-circular
                            v-if="getConnectStatus"
                            color="blue-lighten-3" 
                            indeterminate 
                            :size="20" 
                            :width="2"
                          ></v-progress-circular>
                          <v-icon
                            v-else
                            :class="item.connectionStatus"
                          >cloud_done</v-icon>
                          </v-list-item-icon>
                      </v-list-item>
                      </v-list-item-group>
                  </v-list>
                </v-col>
              
                <v-col sm="9" class="pb-0 pt-0 border-left" v-if="!isError && conectedDetail.length > 0">
                  <v-row align="center" class="mt-0" v-if="otaCode">
                    <v-col sm="4" class="pb-1">
                      <label class="d-flex text-nowrap">{{ $t("SETUP_RATE_TYPE") }}
                        <v-tooltip top nudge-right="200">
                          <template v-slot:activator="{ on, attrs }">
                            <i class="icon-info fs-18 ml-1 text-primary" v-bind="attrs"
                            v-on="on"></i>
                          </template>
                          <div class="fs-13" style="max-width: 500px; padding: 10px 0;" v-html="$t(agodaCode.includes(otaCode) ? 'TOOLTIP_INCLUDE_COMMISSION_AGODA' : 'TOOLTIP_INCLUDE_COMMISSION')"></div>
                        </v-tooltip>
                      </label>
                    </v-col>
                    <v-col sm="4" class="pb-1">
                      <v-select
                        ref="otaRoomSelect"
                        :items="commissionList"
                        item-text="text"
                        item-value="value"
                        v-model="extraUpdate.extra.includedCommission"
                        dense
                        outlined
                        @change="updateExtra()"
                        :disabled="isUpdateExtra"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <i v-if="otaCode" class="text-secondary mb-2 fs-10"> {{ $t("SETUP_RATE_TYPE_NOTE") }} </i>
                  <div class="tbl-connect" @scroll="loadData">
                    <v-row class="d-header-table mr-0 ml-0" style="z-index: 7;">
                        <v-col sm="4" class="pt-0 pb-0">
                          <v-row>
                            <v-col>
                              {{$t('ROOM_TYPE')}}
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col class="pt-0 pb-0">
                            <v-row>
                              <v-col>
                                {{$t('_SALE_PACKAGE.SALE_PACKAGE')}}
                              </v-col>
                              <v-col sm="3">
                                <span >{{$t('STATUS')}}</span>
                              </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row 
                      class="mt-0 border-bottom mr-0 ml-0"
                      v-for="(room, index) in tmpConectedDetail"
                      :key="'conectedDetail_'+index"
                    >
                        <v-col sm="4" class="border-right">
                          <strong class="fs-12">
                            {{room.roomTypeI18n.find(e => e.lang === defaultI18n).name}} ({{ $t("HOTEL_LOG_id")}}
                            : {{ room.roomTypeCode + (room.externalRoomCode ? ' | ' +  room.externalRoomCode : '')}})
                          </strong>
                        </v-col>
                        <v-col class="pt-0 pb-0">
                          <v-row 
                            class="border-bottom mt-0 d-plan"
                            v-for="(rate, ind) in room.ratePlans"
                            :key="'conectedDetail_'+index+'_ratePlans_'+ind"
                          >
                            <v-col>
                              <span>
                                {{rate.ratePlanI18n.find(e => e.lang === defaultI18n).name}} ({{ $t("HOTEL_LOG_id")}}
                                : {{ rate.ratePlanCode + (rate.externalPlanCode ? ' | ' +  rate.externalPlanCode : '')}})
                              </span>
                            </v-col>
                            <v-col sm="2" class="d-middle">
                              <v-switch color="primary" v-model="rate.roomRates[0].status" class="p-0 m-0" :disabled="rate.roomRates[0].connectionStatus === 2"></v-switch>
                            </v-col>
                            <v-col sm="3">
                              <span :class="optionStatus.find(e => e.value === rate.roomRates[0].connectionStatus).text">
                                {{$t(optionStatus.find(e => e.value === rate.roomRates[0].connectionStatus).text)}}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                    </v-row>
                    <div v-if="loadingMore" class="text-center py-2" style="position:sticky; left: 0;">
                      <v-progress-circular
                        :width="2"
                        color="gray"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </div>
                  <div class="text-right mt-3">
                    <v-btn :disabled="isUpdating" class="mr-3" v-if="listOTAConnected.find(e => e.id === selectedItem).connectionStatus === 'CONNECTED-RoomTypeOTA'" outlined color="primary" @click="syncData(selectedItem)"> {{$t('SYNC')}} </v-btn>
                    <v-btn :disabled="isUpdating" depressed color="primary" @click="update()"> {{$t('MAP')}} </v-btn>
                  </div>

                </v-col>
                <v-col v-else sm="9" class="p-0 border-left"  >
                  <v-row style="text-align: center">
                    <v-col sm="12">
                      <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                        >warning</v-icon
                      >
                    </v-col>
                    <v-col sm="12">
                      <p style="margin: auto">
                        {{ $t("ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED") }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <template v-else-if="isErrorConnect">
                <v-col class="p-0"  >
                  <v-row style="text-align: center">
                    <v-col sm="12">
                      <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                        >warning</v-icon
                      >
                    </v-col>
                    <v-col sm="12">
                      <p style="margin: auto">
                        {{ $t("CANNOT_GET_INFO_FROM_OTA_1") }}
                        <br />
                        {{ $t("CANNOT_GET_INFO_FROM_OTA_2") }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <template v-else>
                <v-col class="p-0"  >
                  <v-row style="text-align: center">
                    <v-col sm="12">
                      <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                        >warning</v-icon
                      >
                    </v-col>
                    <v-col sm="12">
                      <p style="margin: auto">
                        {{ $t("NOT_CONNECTED") }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
            </v-row>
            <div v-if="!isVisibleMap && actionTab === 'OTA_CONNECT'" class="h-100">
              <div id="widget-ota"></div>
            </div>
        </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.description-price {
  padding: 10px;
  p {
    margin-bottom: 2px;
    span {
      font-weight: bold;
    }
  }
}
.ifram-ota{
    height: calc(100% - 85px) !important;
}
.d-main{
    height: calc(100vh - 130px);
}
.d-plan:last-child{
  border-bottom: none !important;
}

#widget-ota {
  ::v-deep .disabled {
    pointer-events: auto !important;
  }
}

:deep(#widget-ota .disabled) {
  pointer-events: auto !important;
}
</style>

<script>
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { _alert } from "@/_helpers/function.js";
import { staahMaxOta } from "@/_services/SyncOTA/RoomSaleOta.service.js";
import moment from "moment";

export default {
  data() {
    return {
      sysLang: this.$i18n.locale,
      isLoading: false,
      selectedItem: null,
      listOTAConnected: [],
      actionTab: 'SALE_CHANNEL',
      iframeUrl: null,
      conectedDetail: [],
      isError: false,
      selectIdDetail: null,
      optionStatus: [
        {
          value: 0,
          text: 'NOT_CONNECTED'
        },
        {
          value: 1,
          text: 'CONNECTED'
        },
        {
          value: 2,
          text: 'MISSING_ROOM_AND_PRICE'
        },
        {
          value: 3,
          text: 'CONNECTING'
        },
        {
          value: 4,
          text: 'CONNECTION_FAILED'
        }
      ],
      isIframe: false,
      isErrorConnect: false,
      isVisibleChannel: false,
      isVisibleMap: false,
      tmpConectedDetail: [],
      perPage: 0,
      totalPage: 0,
      itemPerPage: 2,
      loadingMore: false,
      maxHeight: 100,
      getConnectStatus: true,
      isUpdating: false,
      isUpdateExtra: false,
      hasInjectedOtaScript: false,
      otaScriptLoadingPromise: null,
      otaCode: null,
      expediaCodeList: ['EXP', '9', '105', '189'],
      extraUpdate: {
        id: null,
        extra: {
          includedCommission: null
        }
      },
      isLoadingToken: false,
      agodaCode: ['AGO', '189'],
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    commissionList() {
      if (!this.otaCode) return [];
      if (this.expediaCodeList.includes(this.otaCode)) {
        return [
          { text: this.$t('INCLUDE_COMMISSION'), value: true },
          { text: this.$t('EXCLUDE_COMMISSION'), value: false },
          { text: this.$t('UNDEFINED_COMMISSION'), value: -1 }
        ];
      } else {
        return [
          { text: this.$t('INCLUDE_COMMISSION'), value: true },
          { text: this.$t('UNDEFINED_COMMISSION'), value: -1 }
        ];
      }
    }
  },
  created() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const userRole = currentUser.user.roles.map(role => role.fnCode);
    if (userRole.indexOf('STAAH_CONNECTION') < 0) {
        this.isVisibleChannel = true;
    }
    if (userRole.indexOf('STAAH_MAPPING') < 0) {
        this.isVisibleMap = true;
    }
    this.initialize();
  },
  watch: {
    selectedItem(value) {
      // Lấy thông tin chi tiết đồng bộ của 1 kênh
      this.isLoading = true;
      this.isError = false;
      this.conectedDetail = "";
      this.selectIdDetail = value;
      const data = this.listOTAConnected.find(e => e.id == value);
      // this.otaCode = data && data.otaCode && this.expediaCodeList.includes(data.otaCode) ? data.otaCode : null;
      this.otaCode = data.otaCode;
      this.detailOta(value);
    },
    async actionTab(value) {
      if (value === 'OTA_CONNECT') {
        try {
          this.isLoadingToken = true;
          const data = await this.getWidgetToken(this.selectedItem);
          await this.loadOtaMapScript();
          //theo tài liệu thì hiện tại widget chỉ hỗ trợ 3 ngôn ngữ
          // tiếng Trung, tiếng Nhật và tiếng Anh trong danh sách ngôn ngữ đang có của extranet
          const langMap = {zh: 'zn', ja: 'ja'};
          const language = langMap[this.sysLang] || 'en';
          // const channelCode = data.Data.channel_codes.find(code => this.otaCode && code.channel_code == this.otaCode);
          const tmpScriptObj = {
            elementId: "widget-ota",
            type: "channel-Mapping",
            appId: data.ClientId,
            propertyId: data.Data.proppmsid,
            token: data.Data.token_id,
            channelCode: '',
            language: language,
            themeColor: {
              iconColor: "#1e8ce4"
            }
          };
          if (typeof window.loadScript === "function") {
            window.loadScript(tmpScriptObj);
          }
          this.isLoadingToken = false;
        } catch (error) {
          this.isLoadingToken = false;
          const res = {
            responseCode: 1,
            data: "ERROR"
          }
          _alert(res, this.$t(res.data), false);
        }
      } else {
        this.cleanupOtaWidget();
      }
    }
  },
  methods: {
    async getWidgetToken(id) {
      try {
        const res = await staahMaxOta.getStaahMaxWidgetToken(id);
        if (res.responseCode === 0) {
          return res.data;
        } else {
          throw new Error(res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    loadOtaMapScript() {
      if (typeof window.loadScript === "function") {
        return Promise.resolve();
      }

      if (this.otaScriptLoadingPromise) {
        return this.otaScriptLoadingPromise;
      }

      const scriptId = "ota-switch-script";
      const scriptSrc = "https://static.otaswitch.com/JS/script.js";

      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        this.hasInjectedOtaScript = false;
        this.otaScriptLoadingPromise = new Promise((resolve, reject) => {
          const onLoad = () => {
            this.otaScriptLoadingPromise = null;
            resolve();
          };
          const onError = () => {
            this.otaScriptLoadingPromise = null;
            reject(new Error("Failed to load OTA switch script"));
          };
          existingScript.addEventListener("load", onLoad, { once: true });
          existingScript.addEventListener("error", onError, { once: true });
        });
        return this.otaScriptLoadingPromise;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = scriptSrc;
      script.async = true;
      this.otaScriptLoadingPromise = new Promise((resolve, reject) => {
        script.onload = () => {
          this.otaScriptLoadingPromise = null;
          resolve();
        };
        script.onerror = () => {
          this.otaScriptLoadingPromise = null;
          reject(new Error("Failed to load OTA switch script"));
        };
      });
      document.head.appendChild(script);
      this.hasInjectedOtaScript = true;
      return this.otaScriptLoadingPromise;
    },
    removeOtaMapScript() {
      if (!this.hasInjectedOtaScript) {
        return;
      }

      const script = document.getElementById("ota-switch-script");
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      this.hasInjectedOtaScript = false;
      this.otaScriptLoadingPromise = null;
    },
    cleanupOtaWidget() {
      const widget = document.getElementById("widget-ota");
      if (widget) {
        widget.innerHTML = "";
      }

      const injectedFrames = document.querySelectorAll('iframe[src*="otaswitch.com"]');
      injectedFrames.forEach((frame) => {
        if (frame && frame.parentNode) {
          frame.parentNode.removeChild(frame);
        }
      });
    },
    updateExtra() {
      this.isUpdateExtra = true;
      const data = JSON.parse(JSON.stringify(this.extraUpdate));
      data.extra.includedCommission = data.extra.includedCommission != -1 ? data.extra.includedCommission : null;
      data.extra = JSON.stringify(data.extra);
      staahMaxOta
        .updateExtraStaahMax(data)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        }).finally(() => {
          this.isUpdateExtra = false;
        });
    },
    loadData(event) {
      if (this.loadingMore) {
        return;
      }
      const table = event.target;
      const scrollTop = table.scrollTop;
      const clientHeight = table.clientHeight;
      const scrollHeight = table.scrollHeight;

      if (scrollHeight - scrollTop - clientHeight <= 100 && this.perPage < this.totalPage) {
        this.loadingMore = true;
        setTimeout(() => {
            this.tmpConectedDetail = [...this.tmpConectedDetail, ...this.conectedDetail.slice(this.perPage * this.itemPerPage, (this.perPage + 1) * this.itemPerPage)];
          this.perPage += 1;
          this.loadingMore = false;
        }, 1000);
      }
    },
    onResize() {
      this.maxHeight = (window.innerHeight - 290 - 50);
    },
    async syncData(id) {
      this.isUpdating = true;
         await staahMaxOta.staahMaxSyncData(id).then(res => {
          _alert(res, this.$t(res.data), false);
        }).finally(() => (this.isUpdating = false));
      },
    async initialize() {
      this.isLoading = true;
      let body = {
        keyword: "",
        status: 1
      };
      await staahMaxOta.getAllStaahMaxOTA(body).then(res => {
        if (res.responseCode === 0) {
          this.isErrorConnect = false;
            this.listOTAConnected = res.data;
            this.listOTAConnected.forEach(it => {
              it.connectionStatus = it.connectionStatus + "-RoomTypeOTA";
            });
            this.selectedItem = this.listOTAConnected.length > 0 ? this.listOTAConnected[0].id : null;
            if (this.isVisibleMap === false) {
              this.getIframeSu();
            }
        } else {
          this.isErrorConnect = true;
          _alert(res, this.$t(res.data), false);
        }
        this.isLoading = false;
        this.getListSuOTAStatus();
      });
    },
    async getListSuOTAStatus() {
      let body = {
        keyword: "",
        status: 1
      };
      await staahMaxOta.getStatusStaahMaxOTA(body).then(res => {
        if (res.responseCode === 0) {
          const data = res.data;
          data.forEach(it => {
            const SuOTA = this.listOTAConnected.find(e => e.id === it.id);
            SuOTA.connectionStatus = it.connectionStatus + "-RoomTypeOTA";
          });
          this.getConnectStatus = false;
        }
      });
    },
    async getIframeSu() {
      let body = {
        keyword: "",
        status: 1
      };
       await staahMaxOta.getStaahMaxIframe(body).then(res => {
        if (res.responseCode === 0) {
          this.iframeUrl = res.data;
          this.isIframe = this.iframeUrl ? true : false;
        } else {
          this.isIframe = false;
        }
      });
    },
    detailOta(value) {
      this.tmpConectedDetail = [];
      this.conectedDetail = [];
      this.perPage = 0;
      this.totalPage = 0;
      this.itemPerPage = 1;
      const minRow = Math.ceil(this.maxHeight / 40) + 5;
      staahMaxOta
        .detailStaahMaxSyncOTA(value)
        .then(res => {
          if (res.responseCode === 0) {
            const data = res.data;
            let ratePlanLength = 0;
            data.forEach((room) => {
              ratePlanLength += room.ratePlans.length;
              if (ratePlanLength < minRow) {
                this.itemPerPage += 1;
              }
            });
            this.conectedDetail = data;
            if (data.length > 0 && this.otaCode) {
              this.extraUpdate.id = data[0].otaHotelId || null;
              if (data[0].extra) {
                this.extraUpdate.extra = JSON.parse(data[0].extra);
                this.extraUpdate.extra.includedCommission = this.extraUpdate.extra.includedCommission != null ? this.extraUpdate.extra.includedCommission : -1;
              } else {
                //mặc định Expedia, Booking.com, Goibibo là đã bao gồm hoa hồng, các OTA còn lại là không xác định
                const defaultCommission = ['9', '19', '105'].includes(this.otaCode) ? 1 : -1;
                this.extraUpdate.extra.includedCommission = defaultCommission;
              }
            }
            this.totalPage = Math.ceil(this.conectedDetail.length / this.itemPerPage);
            this.tmpConectedDetail = this.conectedDetail.slice(this.perPage * this.itemPerPage, (this.perPage + 1) * this.itemPerPage);
            this.perPage += 1;
          } else {
            if (res.data == "OTA_CONNECTION_ERROR") {
              this.isError = true;
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    update() {
      this.isLoading = true;
      this.isUpdating = true;
      staahMaxOta
        .updateDetailStaahMaxOTA(this.conectedDetail, this.selectedItem)
        .then(res => {
          this.detailOta(this.selectIdDetail);
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => {
          this.isLoading = false;
          this.isUpdating = false;
        });
    },
    _moment: moment
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.cleanupOtaWidget();
    this.removeOtaMapScript();
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  }
};
</script>